export default function() {
  
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  // Template
  function buildSlideTemplateImages(slide) {

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container" style="background-image: url('${slide.ImageWithPath}');" aria-label="${slide.ImageAlternateText}"></div>
      </div>
    `;

    return template;
  }

  // Fetch data
  saffire.utils.getWidgetData(widgetOpts).then(function(response) {
    if (response.Slides.length > 0) {
      initSwiper(response.Slides);
      // console.log(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });


  // Initialize Swiper
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $('.swiperWidget-mainfeature .swiper-wrapper');

    widgetData.forEach(function(slide, i) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
    });

    const swiperWidgetImages = new Swiper('.swiperWidget-mainfeature .swiper-container', {
      speed: 750,
      autoplay: {
        delay: 10000,
      },
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: false,
      autoHeight: true,     
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    }); 

  }

}





